// Product page option redesign: reorders Size/Fabric/Color, removes accordion collapse
// behavior, relabels headers as Step 1/2/3, restyles Fabric swatches into image+label
// cards, renames a couple of collection labels, removes the Type section entirely, and
// moves the existing "Fabric Guide" link up onto the Step 2 header row. Pure DOM
// rearrangement/styling only — does not touch any <a href>, <input>, or Liquid-rendered
// variant logic, so existing product switching / Add to Cart behavior is unaffected.
document.addEventListener('DOMContentLoaded', function () {
  var sizeSection = document.getElementById('size-section');
  var fabricSection = document.getElementById('fabric-section');
  var colorSection = document.getElementById('color-section');
  var typeSection = document.getElementById('type-section');

  // Remove the Type section entirely, on every product that has it.
  if (typeSection) {
    typeSection.remove();
  }

  if (!sizeSection || !fabricSection || !colorSection) return;

  // 1. Reorder: move Size immediately before Fabric. Fabric/Color keep their existing
  // relative order, so the result is Size, Fabric, Color.
  fabricSection.parentNode.insertBefore(sizeSection, fabricSection);

  // 2. Remove accordion collapse behavior + relabel headers.
  var steps = [
    { section: sizeSection, label: 'Step 1: Select Size' },
    { section: fabricSection, label: 'Step 2: Choose Collection' },
    { section: colorSection, label: 'Step 3: Choose Color' }
  ];

  steps.forEach(function (step) {
    var section = step.section;
    if (!section) return;
    section.classList.add('option-section-v2');
    var header = section.querySelector('.accordion-header');
    var content = section.querySelector('.accordion-content');
    if (header) {
      header.removeAttribute('onclick');
      header.innerHTML = '<span class="step-label"></span>';
      header.querySelector('.step-label').textContent = step.label;
    }
    if (content) {
      content.style.display = 'block';
    }
  });

  // 2b. Move the existing "Fabric Guide" link onto the Step 2 (Collection) header row,
  // right-aligned (the header is already display:flex; justify-content:space-between).
  var fabricGuideLink = document.querySelector('a[href*="fabric-guide" i]');
  var fabricHeader = fabricSection.querySelector('.accordion-header');
  if (fabricGuideLink && fabricHeader) {
    fabricGuideLink.removeAttribute('style');
    fabricGuideLink.classList.add('step-header-link');
    fabricGuideLink.textContent = 'Fabric Guide';
    fabricHeader.appendChild(fabricGuideLink);
  }

  // 3. Restyle Fabric options into image + label cards, without touching the
  // underlying <a href> (product switch link) or <input type=radio>.
  var COLLECTION_RENAME = {
    'jacquard-3d': 'Jacquard',
    'microfibra-printed': 'Printed'
  };

  fabricSection.querySelectorAll('a.ColorSwatch').forEach(function (a) {
    if (a.dataset.cardified) return;
    a.dataset.cardified = 'true';

    var bg = a.style.backgroundImage;
    a.classList.add('fabric-card__link');
    a.style.backgroundImage = '';
    a.style.backgroundColor = '';
    a.style.boxShadow = 'none';

    var imageSpan = document.createElement('span');
    imageSpan.className = 'fabric-card__image';
    imageSpan.style.backgroundImage = bg;
    a.insertBefore(imageSpan, a.firstChild);

    var nameSpan = a.querySelector('.u-visually-hidden');
    if (nameSpan) {
      nameSpan.classList.remove('u-visually-hidden');
      nameSpan.classList.add('fabric-card__name');
      var raw = (nameSpan.textContent || '').trim();
      var key = raw.toLowerCase();
      var label;
      if (COLLECTION_RENAME[key]) {
        label = COLLECTION_RENAME[key];
      } else {
        label = key.replace(/-/g, ' ');
        if (label) {
          label = label.charAt(0).toUpperCase() + label.slice(1);
        }
      }
      nameSpan.textContent = label;
    }
  });
});
